import React, { Fragment, useState, useEffect } from 'react'
import cn from 'classnames'
import listen from "@insight/toolkit-utils/lib/events/listen";

import FadeIn from '../IAHeaderMegaMenu/FadeIn'

export default function NiaContainer({ isOpen, setIsOpen }) {
  const handleClick = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    return listen('Nia:close', () => {
      handleClick()
    })
  }, [])

  if(!isOpen) return null;
  return (
    <div className="c-nia-container">
      <FadeIn delay={5}>
        <div className={cn('c-modal', {'is-open': isOpen})}>
            <div className='c-modal-container'>
              <iframe
                id="myIframe"
                src={`https://app-2luyhoszfh4j2.azurewebsites.net/?parentOrigin=${encodeURIComponent(window.location.origin)}`}
                allow="microphone"
              ></iframe>
            </div>
        </div>
      </FadeIn>
    </div>
  )
}


